import { ROUTES } from 'common/constants/app.constants';
import { isUserTypeIsKAM } from 'dedicated/components/plan-and-configuration/configure-plan-pricing-constant';
import React, { useEffect } from 'react';
import { RateCardBody } from './rateCardBody/rateCardBody';
import { RateCardHeader } from './rateCardHeader/rateCardHeader';
import './rateCard.scss';
import { ERROR_MESSAGE, isHeaderSet } from './constant/constant';
import { fetchUserDetails } from './services/rateCard.service';
import { fireAnalyitcsOnPageLoad, setPayLoad } from './analytics/analytics';

type Props = {
  history: { push: Function };
};

export const RateCard = ({ history }: Props) => {
  const setUserData = () => {
    fetchUserDetails().then(({ data }: any = {}) => {
      setPayLoad(data);
      fireAnalyitcsOnPageLoad();
    });
  };
  useEffect(() => {
    if (!isUserTypeIsKAM()) {
      history.push(ROUTES.B2B_FAILURE, { title: ERROR_MESSAGE.UN_AUTHORIZED_TITLE, body: ERROR_MESSAGE.UN_AUTHORIZED_BODY });
    } else {
      setUserData();
    }
  }, []);

  return (
    <>
      {isUserTypeIsKAM() && (
        <>
          <div className="rate-card">
            <RateCardHeader />
            <RateCardBody />
          </div>
        </>
      )}
    </>
  );
};
